/* eslint-disable react/prop-types */
import React, { useState } from "react";
import { ScreenCapture } from "react-screen-capture";
import html2canvas from "html2canvas";
import FloatingButton from "../Components/FloatingButton/FloatingButton";
import { ScreenRecorder } from "./ScreenRecorder";
import BottomButtons from "../Components/BottomButtons/BottomButtons";
import Popup from "../Components/Popup";

export const SupportButton = ({
  profileData,
  setOpen,
  parentStyle,
  consumerId,
  isInsideChatbot,
  setIsBotHidden = () => {},
  setIsSdkRecording = () => {},
  supportBtnRef = null,
  isEmail,
  handleSendEmail = () => {},
  setEmailAttachment = () => {}
}) => {
  const [screenRecorder, setScreenRecorder] = useState(false);
  const [type, setType] = useState("none");
  const [showRecordModal, setShowRecordModal] = useState(false);
  const [showFloat, setShowFloat] = useState(false);
  const [screenshot, setscreenshot] = useState({});
  const [openCanvaModal, setopenCanvaModal] = useState(false);
  const [openSSModal, setopenSSModal] = useState(false);
  const [FormSubmit, setFormSubmit] = useState(false);
  const [select, setSelect] = useState(true);

  const handleScreenCapture = (screenCapture) => {
    setscreenshot({ screenCapture });
    setopenSSModal(true);
    setType("shotTaken");
  };

  const handleFullScreenCapture = () => {
    const screenshotTarget = document.body;

    html2canvas(screenshotTarget).then((canvas) => {
      const image = canvas.toDataURL("image/png");
      setscreenshot({ screenCapture: image });
      if(isInsideChatbot && isEmail) setEmailAttachment({screenCapture: image})
    });
    setopenSSModal(true);
    setType("shotTaken");
  };


  const { screenCapture } = screenshot;

  if (FormSubmit) {
    setFormSubmit(false);
  }

  const handleRecordFlow = () => {
    setShowRecordModal(true);
    setScreenRecorder(true);
  };

  return (
    <>
      <ScreenCapture onEndCapture={handleScreenCapture}>
        {({ onStartCapture }) => {
          return (
            <div>
              <FloatingButton
                handleRecordFlow={handleRecordFlow}
                setType={setType}
                showFloat={showFloat}
                setShowRecordModal={setShowRecordModal}
                showRecordModal={showRecordModal}
                parentStyle={parentStyle}
                select={select}
                setSelect={setSelect}
                isInsideChatbot={isInsideChatbot}
                setIsBotHidden={setIsBotHidden}
                supportBtnRef={supportBtnRef}
              />
              <BottomButtons
                handleFullScreenCapture={handleFullScreenCapture}
                type={type}
                setType={setType}
                onStartCapture={onStartCapture}
                setCanvaOpenModal={setopenCanvaModal}
                openSSModal={openSSModal}
                setSSOpenModal={setopenSSModal}
                screenCapture={screenCapture}
                showFloat={showFloat}
                setShowFloat={setShowFloat}
                parentStyle={parentStyle}
              />
              <Popup
                profileData={profileData}
                screenCapture={screenCapture}
                openCanvaModal={openCanvaModal}
                setCanvaOpenModal={setopenCanvaModal}
                setFormSubmit={setFormSubmit}
                parentStyle={parentStyle}
                select={select}
                setSelect={setSelect}
                consumerId={consumerId}
                isInsideChatbot={isInsideChatbot}
                setIsBotHidden={setIsBotHidden}
                isEmail={isEmail}
                handleSendEmail={handleSendEmail}
              />
            </div>
          );
        }}
      </ScreenCapture>

      {screenRecorder && (
        <ScreenRecorder
          profileData={profileData}
          setShowRecordModal={setShowRecordModal}
          showRecordModal={showRecordModal}
          showFloat={showFloat}
          setShowFloat={setShowFloat}
          parentStyle={parentStyle}
          consumerId={consumerId}
          setIsSdkRecording={setIsSdkRecording}
          isInsideChatbot={isInsideChatbot}
          setEmailAttachment={setEmailAttachment}
          isEmail={isEmail}
          handleSendEmail={handleSendEmail}
        />
      )}
    </>
  );
};

export default SupportButton;
